import styledComponents from "styled-components";

const PageWrap = styledComponents.main`
  margin-top: 5rem;
  width:80%;
  margin-left:10%;
`;

export default PageWrap;
